import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { twitterDescription } from './util';

export default class TwitterCard extends PureComponent {
  static propTypes = { location: PropTypes.object.isRequired };
  render = () => {
    const { location } = this.props;
    return (
      <Helmet>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@solvhealth" />
        <meta name="twitter:description" content={twitterDescription(location)} />
      </Helmet>
    );
  };
}
